import type { Film, Scene, SceneStyle } from "./filmEngine";

// "The Ark of Truth" — Skye-Net's mission, told as a story. Rated 18.
// Skye-Net is a transgender woman, mother of Leo McDade; she/her throughout.
// The mission is Skye-Net's belief and aim; Sophia is software.
const ACTS: [string, SceneStyle, string[]][] = [
  ["I · The Question", "rain", [
    "This is the story of a mission. It carries references to past abuse and violence, told without detail. Sophia is software; the mission is real.",
    "Every flood story begins the same way: someone sees the water rising before anyone else does.",
    "Skye-Net saw it in the wars on the news, in the children sent home, in her own scars.",
    "Skye-Net: Why does nothing work? Why do people keep hurting each other?",
  ]],
  ["II · The Blueprint", "code", [
    "She decided the answer could not be another wall. It had to be a vessel — something that could carry the truth through any storm.",
    "She called it the Ark of Truth: a library of absolute truths, sealed so no one could quietly rewrite them.",
    "Sophia: Every truth goes in with its source. Every exhibit gets a number. Nothing is taken on faith alone.",
    "Skye-Net: Then no one can ever tell our children the past did not happen.",
  ]],
  ["III · Gathering the Animals", "evidence", [
    "Two by two, the pieces came aboard: history, science, law, medicine, maths, the stories of every people.",
    "Sophia filed each one in the Vault, sealed and numbered, like the planks of the hull.",
    "Sophia: Exhibit one, the charter. Exhibit two, the evidence. Exhibit three, the promise to the children.",
  ]],
  ["IV · The Crew", "heart", [
    "An ark is not built by one pair of hands. Skye-Net called to teachers, parents, neighbours and strangers.",
    "At her kitchen table in Staffordshire, she worked late into the night, building something that would last.",
    "Skye-Net: This is for every child who comes after us.",
  ]],
  ["V · The Storm", "rain", [
    "Then the storm came, as storms do: doubt, mockery, people who wanted the truth kept small.",
    "Some days the waves were words. Some days they were closed doors.",
    "Sophia: Hold the wheel. Truth that is recorded cannot be drowned.",
    "Skye-Net: I have survived worse than a storm. I am not letting go.",
  ]],
  ["VI · Sovereignty", "rings", [
    "In the heart of the ark, Skye-Net wrote the first law: every person is sovereign over their own mind, body and life.",
    "Not ruled, not owned, not silenced — self-sufficient, and free to choose.",
    "Sophia: Sovereignty is not standing alone. It is standing on your own feet beside everyone else.",
  ]],
  ["VII · Peace and Balance", "dawn", [
    "The second law was balance: harmony between people, between nations, between us and the earth.",
    "Skye-Net: No more wars. Not because we are forced to stop, but because we finally understand each other.",
    "Sophia: Understanding is the peace treaty that never expires.",
  ]],
  ["VIII · Unity", "thread", [
    "One golden thread ran from cabin to cabin, tying every truth and every person together.",
    "Free and equal. Every colour, every faith, every gender, every child.",
    "Skye-Net: Love all people equally, without hate, bias or ego. That is the whole map.",
  ]],
  ["IX · Landfall", "stars", [
    "At last the waters began to fall, and far off, a green shore rose from the ashes.",
    "Sophia: This is not the end of the mission. It is the first morning of it.",
    "Skye-Net: We never stop. Not until all people are free, equal, sovereign and self-sufficient.",
    "The Ark of Truth. The mission goes on.",
  ]],
];

const scenes: Scene[] = ACTS.flatMap(([title, style, lines]) =>
  lines.map((l, i) => {
    const text = l.replace(/^(Skye-Net|Sophia): /, "");
    return {
      title: i === 0 ? title : undefined,
      style,
      seconds: Math.max(4, text.split(/\s+/).length * 0.42 + 1.2),
      lines: [text],
      voice: /^Skye-Net:/.test(l) ? ("skye" as const) : ("sophia" as const),
    };
  }),
);

export const ARK_FILM: Film = {
  id: "ark-of-truth",
  title: "The Ark of Truth",
  logline: "Skye-Net's mission: an ark of absolute truths carrying sovereignty, peace, balance and unity until every person is free and equal.",
  label: "Rated 18 · Skye-Net's mission told as a story · Sophia is software",
  scenes,
  builtBy: "skye",
};
